// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3yUAH","text":"SelectPayment_text__3QZN8","title":"SelectPayment_title__K2IGQ","btn":"SelectPayment_btn__1cGhE"};